import React from 'react';

import { Typography } from '@mui/material';
import { AlineButton } from 'src/components';
import { makeStyles } from 'tss-react/mui';

import { useGlobalDrawer } from '../GlobalRightDrawer';

const useStyles = makeStyles()(theme => ({
  root: {
    alignItems: 'center',
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    gap: theme.spacing(2),
    height: '100%',
    justifyContent: 'center',
    padding: theme.spacing(3),
  },
}));

/** Stands in for a drawer section that a focused view does not offer. */
export function FocusedViewNotAvailable(): JSX.Element {
  const { classes } = useStyles();
  const { closeDrawer } = useGlobalDrawer();

  return (
    <div className={classes.root}>
      <Typography align="center" color="text.secondary" variant="body2">
        You are not authorized to access this section of the app.
      </Typography>
      <AlineButton color="primary" size="small" variant="contained" onClick={closeDrawer}>
        Close Panel
      </AlineButton>
    </div>
  );
}
